$(document).ready(function() {
  
  // ANIMATION
  
  if ($(".content_anim").length > 0) {
    console.log('content_anim');
    $('.content_anim blockquote *').addClass('anim_false');
    $('.content_anim h1:not(.anim_false), .content_anim h2:not(.anim_false), .content_anim h3:not(.anim_false), .content_anim h4:not(.anim_false), .content_anim h5:not(.anim_false), .content_anim h6:not(.anim_false), .content_anim p:not(.anim_false), .content_anim li:not(.anim_false), .content_anim blockquote:not(.anim_false), .content_anim img:not(.anim_false), .content_anim video:not(.anim_false), .content_anim .btn:not(.anim_false), .content_anim hr:not(.anim_false)').addClass('anim anim_bottom');
    $('.content_anim p img').parent('p').css({'opacity': '1'});
  }
  
  function onEntrySlide(entry) {
    entry.forEach(change => {
      if (change.isIntersecting) {
        change.target.classList.add('anim_show');
        change.target.classList.remove('anim');
      }
    });
  }
  
  let options = { threshold: [0,0.5] };
  
  let observer_slide = new IntersectionObserver(onEntrySlide, options);
  let elements_slide = document.querySelectorAll('.anim');
  for (let elm_show of elements_slide) {
    observer_slide.observe(elm_show);
  }

  if (window.location.href.indexOf('mymagichealer.myshopify.com') >= 0) {
    $('body').addClass('js-no-anim');
  }

 $(".js-scroll-to-products").on("click", function(e){
      e.preventDefault();
      if ($('.js-scroll-for-products').length > 0) {
          $('html, body').stop().animate({scrollTop: $('.js-scroll-for-products').offset().top - 50}, 900);
      } else if ($('.custom-lp-products').length > 0) {
          $('html, body').stop().animate({scrollTop: $('.custom-lp-products').offset().top - 200}, 900);
      } 
  });

  $(document).on("click", ".jdgm-prev-badge, .jdgm-prev-badge__text", function(e){
      var $reviews = $('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg').first();

      if ($reviews.length > 0) {
          e.preventDefault();
          $('html, body').stop().animate({scrollTop: $reviews.offset().top - 50}, 900);
      }
  });

  $(document).on("click", ".lp-hsv2__stars-bar, .js-scroll-to-reviews", function(e){
      var $reviews = $('#caj-section-custom-id, .caj-scroll-anchor, .caj-section').first();

      e.preventDefault();

      if ($reviews.length > 0) {
          var offset = window.innerWidth < 990 ? 16 : 100;
          $('html, body').stop().animate({scrollTop: $reviews.offset().top - offset}, 900);
      } else if ($('.js-scroll-for-products').length > 0) {
          $('html, body').stop().animate({scrollTop: $('.js-scroll-for-products').offset().top - 50}, 900);
      }
  });
  
  $(".js-scroll-to-top").on("click", function(e){
    e.preventDefault();
    $('html, body').stop().animate({scrollTop: 0}, 300);
  });

  $(".js-disable-link").on("click", function(e){
    e.preventDefault();
  });
  
  $(".js-disable-link").each(function(index, el) {
      if ($(this).attr('src') != '') {
          $(this).attr('src', '#');
      }
  });

});
